export enum ReportGroup {
  DISCHARGE_SUMMARY = 29,
}
